/**
 * Function that formats a number to 2 decimal places
 * @param {number} num - Number that will be formatted
 */

export const twoDecimals = (num) => {
  return parseFloat(num).toFixed(2);
};
